import { styled } from "@mui/material";
import { IStyledHeaderProps } from "./types";

const StyledHeader = styled('div')<IStyledHeaderProps>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));

export {StyledHeader}